<!--
 * @Author: Lemon C
 * @Date: 2024-04-24 14:08:45
 * @LastEditTime: 2025-01-07 16:23:06
-->
<template>
    <div class="scroll-top-button" @mousedown="startDrag" @click.stop="scrollToTop" :style="{ top: posY + 'px' }">
        <div class="scroll-top-button-content">
            <img src="@/assets/imgs/general/scroll_top_btn.png" alt="" />
        </div>
        <span class="scroll-top-button-title" @click="scrollTopClick(true)">移动到顶部</span>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue';
import { useMessageStore } from '../../stores/message';

const message_store = useMessageStore();

const { proxy } = getCurrentInstance();

const props = defineProps({
    scroll_top_Callback: Function,
});

const dragging = ref(false); // 当前是否在拖动
const posY = ref(window.innerHeight - 100); // 默认的Y坐标位置
const startMouseY = ref(0); // 鼠标拖动初始Y值

onMounted(() => {
    message_store.addMessageHandler(message_store.M_E_SCROLL_TOP, scrollTopClick);
});

onBeforeUnmount(() => {
    message_store.removeMessageHandler(message_store.M_E_SCROLL_TOP, scrollTopClick);
});

// MARK Scroll 滚动到顶部
const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
};
// MARK Drag 开始拖拽
const startDrag = (event) => {
    dragging.value = true;
    startMouseY.value = event.clientY - posY.value;
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('mouseup', stopDrag);
};
// MARK Drag 停止拖拽
const stopDrag = () => {
    dragging.value = false;
    document.removeEventListener('mousemove', onDrag);
    document.removeEventListener('mouseup', stopDrag);
};
// MARK Drag 正在拖拽
const onDrag = (event) => {
    if (dragging.value) {
        const newY = event.clientY - startMouseY.value;
        const screenHeight = window.innerHeight;
        // 确保按钮不会超出屏幕边界
        if (newY > 0 + 40 && newY + proxy.$el.offsetHeight < screenHeight) {
            posY.value = newY;
        }
    }
};
// MARK Click 点击滚动到顶部
const scrollTopClick = (animation) => {
    props.scroll_top_Callback(animation);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.scroll-top-button {
    position: fixed;
    right: -105px;
    padding: 5px 0px 5px 5px;
    box-sizing: border-box;
    border: 1px solid var(--color-main-border-gray);
    cursor: pointer;
    user-select: none;
    z-index: var(--scorll-top-z-index);
    width: 160px;
    height: 46px;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    display: flex;
    align-items: center;
    transition: right 0.3s ease-in-out;
    overflow: hidden;
    box-shadow: var(--color-main-scroll-top-shadow);
    background-color: var(--color-main-light-bg);
}

.scroll-top-button-content {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 20px;
    img {
        width: 100%;
        height: 100%;
    }
}

.scroll-top-button-title {
    position: relative;
    margin-left: 15px;
    font-size: 17px;
    width: 100%;
    height: 100%;
    color: var(--color-main-text-primary);
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
}

.scroll-top-button:hover {
    right: 0px;
}
</style>
